import React from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../../Provider'
import { MuiButtonVariants, OPButton } from '../../../OPcomponents/OPButton'
import { generateDocument } from '../utils/generateDocument'
import { useCVSettings } from './CVSettingsContext'

export const CVDownloadButton = ({ variant }: { variant: 'TOP' | 'BOTTOM' }) => {
  const { t } = useTranslation()
  const rootStore = useStore()
  const { PersonCVInfo, loadingCV } = rootStore.personStore

  const { state } = useCVSettings()

  const isTopVariant = variant === 'TOP'

  return (
    <OPButton
      size='large'
      disabled={loadingCV}
      buttonVariant={isTopVariant ? MuiButtonVariants.primary_outlined : MuiButtonVariants.primary}
      onClick={() => generateDocument(PersonCVInfo, state)}
      label={t('CVTemplates.DownloadCV')}
      sx={isTopVariant ? {} : { fontSize: '1.2rem', padding: '12px 24px', minWidth: '250px' }}
    />
  )
}
